export default {
  navigation: {
    myContentCreatorStudio: "Quản lý Nội dung", //"Studio Nhà Sáng Tạo", //Quản lý Nội dung & Bản quyền
    worksManagement: "Quản lý Tác Phẩm",
    registerWorks: "Đăng ký Tác phẩm mới",
    manageCatalog: "Quản lý Danh mục",
    updateMetadata: "Cập nhật Metadata",
    publishContent: "Xuất bản Tác phẩm",

    paymentsRevenue: "Thanh toán & Doanh thu",
    paymentDashboard: "Tổng quan Thanh toán",
    myLicenses: "Giấy phép của tôi",
    myInvoices: "Hóa đơn của tôi",
    installmentPayments: "Cài đặt Thanh toán",
    refundManagement: "Yêu cầu & Xử lý Hoàn tiền",
    revenueAndPayments: "Doanh Thu & Thanh Toán",
    revenueStatistics: "Thống kê doanh thu",
    copyrightPayout: "Rút tiền từ bản quyền",

    protectionSupport: "Hỗ trợ bảo vệ",
    rightsProtection: "Bảo Vệ Quyền Sở Hữu",
    violationReportsManagement: "Quản lý báo cáo vi phạm",
    myReports: "Báo cáo của tôi",
    reportViolation: "Báo cáo vi phạm",
    createDispute: "Gửi Khiếu nại Bản quyền",
    identityProtectionCenter: "Trung tâm bảo vệ danh tính",
    aiAutoScan: "Quét tự động bằng AI",

    licensingContracts: "Hợp đồng cấp phép",
    licenseStore: "Mua Sắm Bản Quyền",
    discoverWorks: "Khám phá tác phẩm có bản quyền",
    licensePurchase: "Mua giấy phép sử dụng",
    payments: "Thanh toán phí bản quyền",
    requestMarketplaceLicense: "Yêu cầu Cấp phép",
    myMarketplaceRequests: "Yêu cầu Cấp phép của tôi",

    contractManagement: "Quản lý Hợp Đồng",
    viewContracts: "Xem hợp đồng hiện tại",
    manageContracts: "Gia hạn/Hủy hợp đồng",

    documents: "Quản lý Tài liệu",
    allDocuments: "Thư viện tài liệu",
    uploadDocument: "Tải lên tài liệu",
    myDocuments: "Tài liệu của tôi",
    purchasedDocuments: "Tài liệu đã mua",

    systemAdministration: "Quản Trị Hệ Thống",
    userManagement: "Quản lý người dùng",
    systemConfiguration: "Cấu hình hệ thống",
    activityLogs: "Nhật ký hoạt động",
    apiManagement: "Quản lý API",

    staffTasks: "Công Việc Nhân Viên",
    processContracts: "Xử lý hợp đồng",
    contentModeration: "Kiểm duyệt nội dung",
    customerSupport: "Hỗ trợ khách hàng",

    monitoring: "Giám Sát Vi Phạm",
    aiScan: "Quét vi phạm bằng AI",
    warnings: "Gửi cảnh báo vi phạm",
    revocation: "Thu hồi giấy phép",

    legal: "Xử Lý Pháp Lý",
    disputes: "Giải quyết tranh chấp",
    violations: "Xử lý vi phạm",
    enforcement: "Thực thi luật bản quyền",

    explore: "Tìm hiểu",
    exploreDiscoverWorks: "Khám phá tác phẩm",
    licenseInfo: "Thông tin cấp phép",

    documents2: "Tài liệu",
    allDocuments2: "Thư viện tài liệu",
    searchDocuments: "Tìm kiếm tài liệu",

    business: "Phát Triển Kinh Doanh", // "Business Development",
    contractManagement2: "Quản lý hợp đồng", // "Contract Management",
    partnershipManagement: "Quản lý đối tác", // "Partnership Management",
    growthManagement: "Quản lý tăng trưởng", // "Growth Management",

    support: "Hỗ Trợ & Kiểm Soát", // "Support & Control",
    techSupport: "Hỗ trợ kỹ thuật", // "Technical Support",
    faqHelp: "Hỏi đáp thường gặp", // "Frequently Asked Questions",
    userOnboarding: "Hướng dẫn người dùng mới", // "New User Onboarding",

    security: "Bảo Mật & Rủi Ro", // "Security & Risk",
    monitorSecurity: "Giám sát bảo mật", // "Security Monitoring",
    implementSecurity: "Triển khai bảo mật", // "Security Implementation",
    analyzeRisk: "Phân tích rủi ro", // "Risk Analysis",
    preventRisk: "Phòng ngừa rủi ro", // "Risk Prevention",

    violationDashboard: "Tổng quan Vi phạm",
    legalViolations: "Quản lý Vi phạm",

    certificatesCompliance: "Giấy phép",
    certificateManagement: "Quản lý Giấy phép",
    vietrroCertificate: "Giấy phép Vietrro",
    wipoCertificate: "Giấy phép WIPO",
    noipCertificate: "Giấy phép NOIP",
    associationLicenses: "Giấy phép Hiệp hội",
    licenseApproval: "Duyệt đơn đăng ký",
    certificateVerification: "Xác thực giấy phép",
    licenseTracking: "Theo dõi đơn đăng ký",
    licenseHistory: "Lịch sử giấy phép",

    certificateIntegrations: "Đăng ký Cấp phép",
    vietrroWipoIntegration: "Đăng ký VIETRRO/WIPO",
    wipoIntegration: "Đăng ký WIPO",
    vietrroIntegration: "Đăng ký VIETRRO",
    noipIntegration: "Đăng ký NOIP",
    associationIntegration: "Đăng ký với các Hiệp hội khác",

    certificateApproval: "Phê duyệt Giấy phép",
    certificateHistoryAdmin: "Lịch sử tất cả giấy phép",
    certificateVerificationAdmin: "Xác thực và kiểm tra",

    certificateMonitoring: "Giám sát Giấy phép",
    certificateVerificationMonitor: "Xác thực giấy phép",
    licenseTrackingMonitor: "Theo dõi đơn đăng ký",

    certificatePublic: "Xác thực Giấy phép",
    certificateVerificationPublic: "Xác thực giấy phép",

    marketplace: "Marketplace",
    marketplaceHome: "Hoạt động",
    browseContent: "Mua/bán",
    marketplaceDashboard: "Tổng quan Marketplace",
    

    creatorTools: "Công cụ dành cho tác giả",
    creatorDashboard: "Tổng quan Tác giả",
    contentManagement: "Quản lý Nội dung",
    creatorAnalytics: "Phân tích Tác giả",
    incomingRequests: "Yêu cầu từ người mua",
    payoutManagement: "Quản lý Thanh toán",

    preLicenseSystem: "Hệ thống cấp phép sơ bộ",
    searchInternationalWorks: "Tìm kiếm Tác phẩm quốc tế",
    preLicenseRequest: "Yêu cầu cấp phép sơ bộ",
    trackPreLicense: "Theo dõi tiến trình cấp phép",

    authorFinder: "Trình tìm kiếm Tác giả",
    browseUnclaimedContent: "Duyệt Tác phẩm chưa có chủ sở hữu",
    vietrroVault: "Kho lưu trữ Vietrro",
    orphanContent: "Tác phẩm mồ côi",
    myClaimRequests: "Yêu cầu xác nhận Quyền sở hữu của tôi",
    contentVerification: "Xác minh Nội dung",

    marketplaceAdministration: "Marketplace (A)",
    marketplaceDashboardAdmin: "Tổng quan Marketplace",
    marketplaceContentModeration: "Kiểm duyệt Nội dung Marketplace",
    claimReviewAdministration: "Xem xét Khiếu nại",
    marketplaceAnalytics: "Phân tích Marketplace",
    paymentConfirmation: "Xác nhận thanh toán",

    adminPaymentManagement: "Quản lý Thanh toán",
    paymentOverview: "Tổng quan Thanh toán",
    paymentVerification: "Xác minh Thanh toán",
    transactionManagement: "Quản lý Giao dịch",
    refundApproval: "Phê duyệt Hoàn tiền",

    adminDisputeManagement: "Quản lý Khiếu nại",
    disputeQueue: "Khiếu nại chờ xử lý",

    adminLicenseMonitoring: "Giám sát Giấy phép",
    licenseActivationMonitor: "Giám sát kích hoạt Giấy phép",

    marketplaceMonitoring: "Marketplace (M)",
    marketplaceViolations: "Vi phạm trên Marketplace",
    marketplaceContentScanning: "Quét Nội dung",

    marketplaceLegal: "Marketplace (L)",
    marketplaceDisputes: "Khiếu nại",
    marketplaceCompliance: "Quy định trên Marketplace",
    claimReviewLegal: "Xem xét Khiếu nại",

    marketplaceBusiness: "Marketplace (B)",
    marketplacePartnerships: "Đối tác",
    marketplaceRevenue: "Doanh thu",
    marketplaceGrowthAnalysis: "Phân tích Tăng trưởng",

    marketplaceSecurity: "Marketplace (S)",
    marketplaceFraudDetection: "Phát hiện Gian lận",
    marketplaceRiskAssessment: "Đánh giá Rủi ro",
    marketplaceSecurityMonitoring: "Giám sát Marketplace",

    marketplacePublic: "Marketplace (P)",
    browseMarketplace: "Khám phá Marketplace",
    searchContent: "Tìm kiếm Nội dung",
    authorFinderPublic: "Tìm Tác giả",
    verifyContent: "Xác minh Tính xác thực Nội dung"
  },
};
